import { ActivatedRouteSnapshot, Routes } from '@angular/router';

import { ClientConfigProductName } from '@frontend/vanilla/core';

import { SamePathAppVersion } from '../app.version.enum';
import { allowedProductGuard, isSportsVersionMatch, matchAppVersionProductLoadGuard } from '../guards';
import { viewTransitionAnimationGuard } from '../view-transition/view-transition-animation.guard';

export default [
    {
        path: 'sports',
        loadChildren: () => import('@frontend/sports/web/entrypoint-lib').then((t) => t.SPORTS_WEB_ROUTES),
        canMatch: [
            allowedProductGuard,
            (route: ActivatedRouteSnapshot) =>
                matchAppVersionProductLoadGuard(ClientConfigProductName.SPORTS, SamePathAppVersion.SPORTS_WEB_APP, route),
        ],
        canActivateChild: [viewTransitionAnimationGuard],
        data: {
            product: ClientConfigProductName.SPORTS,
            canPreload: [isSportsVersionMatch(SamePathAppVersion.SPORTS_WEB_APP), allowedProductGuard],
        },
    },
] satisfies Routes;
